module.exports = __webpack_public_path__ + "static/media/notification.bc5d69a3.mp3";